/* tslint:disable: member-ordering */
import { Injectable } from '@angular/core';
import { ActionWithPayload } from '../../app.interfaces';

import {
  AssessmentMetadata,
  AssessmentProgress
} from './assessment.interfaces';

@Injectable()
export class AssessmentActions {
  static SET_METADATA = '[Assessment] Set metadata';
  setMetadata(metadata: AssessmentMetadata): ActionWithPayload {
    return {
      type: AssessmentActions.SET_METADATA,
      payload: metadata
    };
  }

  static INTERRUPT_ATTEMP = '[Assessment] Interrupt attemp';
  interruptAttemp(): ActionWithPayload {
    return {
      type: AssessmentActions.INTERRUPT_ATTEMP
    };
  }

  static RESEND_PROGRESS_AFTER_RECONNECT = '[Assessment] Resend progress after reconnect';
  resendProgressAfterReconnect(): ActionWithPayload {
    return {
      type: AssessmentActions.RESEND_PROGRESS_AFTER_RECONNECT
    };
  }

  static INCREMENT_FREEZE_COUNT = '[Assessment] Increment freeze count';
  incrementFreezeCount(): ActionWithPayload {
    return {
      type: AssessmentActions.INCREMENT_FREEZE_COUNT
    };
  }

  static FORCE_VIEW_TIME_SYNC = '[Assessment] Force view time sync';
  forceViewTimeSync(isAuto?): ActionWithPayload {
    return {
      type: AssessmentActions.FORCE_VIEW_TIME_SYNC,
      payload: isAuto === true
    };
  }

  static SET_PROGRESS = '[Assessment] Set progress';
  setProgress(progress: AssessmentProgress): ActionWithPayload {
    return {
      type: AssessmentActions.SET_PROGRESS,
      payload: progress
    };
  }

  static SET_RESULTS = '[Assessment] Set results';
  setResults(results): ActionWithPayload {
    return {
      type: AssessmentActions.SET_RESULTS,
      payload: results
    };
  }

  static START_TEST = '[Assessment] Start test';
  startTest(): ActionWithPayload {
    return {
      type: AssessmentActions.START_TEST
    };
  }

  static LOCK_TEST = '[Assessment] Lock test';
  lockTest(): ActionWithPayload {
    return {
      type: AssessmentActions.LOCK_TEST
    };
  }

  static SET_ANSWER = '[Assessment] Set answer';
  setAnswer(ids): ActionWithPayload {
    return {
      type: AssessmentActions.SET_ANSWER,
      payload: ids
    };
  }

  static SET_ANSWER_SUCCESS = '[Assessment] Set answer success';
  setAnswerSuccess(data?): ActionWithPayload {
    return {
      type: AssessmentActions.SET_ANSWER_SUCCESS,
      payload: data
    };
  }

  static SET_ANSWER_FAIL = '[Assessment] Set answer fail';
  setAnswerFail(data?): ActionWithPayload {
    return {
      type: AssessmentActions.SET_ANSWER_FAIL,
      payload: data
    };
  }

  static SET_QUEUE = '[Assessment] Set ricette queue';
  setQueue(queue): ActionWithPayload {
    return {
      type: AssessmentActions.SET_QUEUE,
      payload: queue
    };
  }

  static SET_RICETTA = '[Assessment] Set ricetta';
  setRicetta(ricetta): ActionWithPayload {
    return {
      type: AssessmentActions.SET_RICETTA,
      payload: ricetta
    };
  }

  static UPDATE_RICETTE = '[Assessment] Update ricetta';
  updateRicette(ricette): ActionWithPayload {
    return {
      type: AssessmentActions.UPDATE_RICETTE,
      payload: ricette
    };
  }

  static SET_SECTION_VIEW_TIME_SUCCESS = '[Assessment] Set section view time success';
  setSectionViewTimeSuccess(res?): ActionWithPayload {
    return {
      type: AssessmentActions.SET_SECTION_VIEW_TIME_SUCCESS,
      payload: res
    };
  }

  static SET_SECTION_VIEW_TIME_FAIL = '[Assessment] Set section view time fail';
  setSectionViewTimeFail(err?): ActionWithPayload {
    return {
      type: AssessmentActions.SET_SECTION_VIEW_TIME_FAIL,
      payload: err
    };
  }

  static SET_CURRENT_QUESTION_ID = '[Assessment] Set current question id';
  setCurrentQuestionId(question): ActionWithPayload {
    return {
      type: AssessmentActions.SET_CURRENT_QUESTION_ID,
      payload: question
    };
  }

  static SET_CURRENT_SECTION_ID = '[Assessment] Set current section id';
  setCurrentSectionId(section): ActionWithPayload {
    return {
      type: AssessmentActions.SET_CURRENT_SECTION_ID,
      payload: section
    };
  }

  static SET_QUESTIONS_MAP = '[Assessment] Set questions map';
  setQuestionsMap(map): ActionWithPayload {
    return {
      type: AssessmentActions.SET_QUESTIONS_MAP,
      payload: map
    };
  }

  static REQUEST_TERMINATE_TEST = '[Assessment] Request terminate test';
  requestTerminateTest(): ActionWithPayload {
    return {
      type: AssessmentActions.REQUEST_TERMINATE_TEST
    };
  }

  static TERMINATE_TEST_SUCCESS = '[Assessment] Terminate test success';
  terminateTestSuccess(results): ActionWithPayload {
    return {
      type: AssessmentActions.TERMINATE_TEST_SUCCESS,
      payload: results
    };
  }

  static TERMINATE_TEST_FAIL = '[Assessment] Terminate test fail';
  terminateTestFail(err): ActionWithPayload {
    return {
      type: AssessmentActions.TERMINATE_TEST_FAIL,
      payload: err
    };
  }

  static REQUEST_NEW_SECTION = '[Assessment] Request new section';
  requestNewSection(id): ActionWithPayload {
    return {
      type: AssessmentActions.REQUEST_NEW_SECTION,
      payload: id
    };
  }

  static REQUEST_NEW_SECTION_BEFORE = '[Assessment] Request new section before';
  requestNewSectionBefore(id): ActionWithPayload {
    return {
      type: AssessmentActions.REQUEST_NEW_SECTION_BEFORE,
      payload: id
    };
  }

  static REQUEST_NEW_SECTION_FAIL = '[Assessment] Request new section fail';
  requestNewSectionFail(err): ActionWithPayload {
    return {
      type: AssessmentActions.REQUEST_NEW_SECTION_FAIL,
      payload: err
    };
  }

  static REQUEST_NEW_SECTION_SUCCESS = '[Assessment] Request new section success';
  requestNewSectionSuccess(id): ActionWithPayload {
    return {
      type: AssessmentActions.REQUEST_NEW_SECTION_SUCCESS,
      payload: id
    };
  }

  static REQUEST_RICETTE_SUCCESS = '[Assessment] Request ricette success';
  requestRicetteSuccess(): ActionWithPayload {
    return {
      type: AssessmentActions.REQUEST_RICETTE_SUCCESS
    };
  }

  static REQUEST_FIRST_AVALIABLE_RICETTA_SUCCESS = '[Assessment] Request first available ricetta success';
  requestFirstAvailableRicettaSuccess(): ActionWithPayload {
    return {
      type: AssessmentActions.REQUEST_FIRST_AVALIABLE_RICETTA_SUCCESS
    };
  }

  static START_PROCESS_QUEUE = '[Assessment] Start process queue';
  startProcessQueue(): ActionWithPayload {
    return {
      type: AssessmentActions.START_PROCESS_QUEUE
    };
  }

  static REQUEST_RICETTE_FAIL = '[Assessment] Request ricette fail';
  requestRicetteFail(err): ActionWithPayload {
    return {
      type: AssessmentActions.REQUEST_RICETTE_FAIL,
      payload: err
    };
  }

  static SEND_LOG = '[Assessment] Send log';
  sendLog(): ActionWithPayload {
    return {
      type: AssessmentActions.SEND_LOG
    };
  }

  static NEW_IMAGE_RECEIVED = '[Assessment] New image received';
  newImageReceived(data): ActionWithPayload {
    return {
      type: AssessmentActions.NEW_IMAGE_RECEIVED,
      payload: data
    };
  }

  static SET_QUESTION_REFRESH_ENABLED = '[Assessment] Set question refresh enabled';
  setQuestionRefreshEnabled(data): ActionWithPayload {
    return {
      type: AssessmentActions.SET_QUESTION_REFRESH_ENABLED,
		payload: data
    };
  }

  static SET_RICETTA_LOADED = '[Assessment] Set ricetta loaded';
  setRicettaLoaded(id_ricetta: any, loaded: boolean): ActionWithPayload {
    return {
      type: AssessmentActions.SET_RICETTA_LOADED,
      payload: {
        id_ricetta,
        loaded
      }
    };
  }

  static SET_RICETTA_USER_REQUESTED = '[Assessment] Set ricetta user requested';
  setRicettaUserRequested(id_ricetta: any, requested: boolean): ActionWithPayload {
    return {
      type: AssessmentActions.SET_RICETTA_USER_REQUESTED,
      payload: {
        id_ricetta,
        requested
      }
    };
  }

  static SET_NEW_SECTION_LOADING = '[Assessment] Set new section loading';
  setNewSectionLoading(data: boolean): ActionWithPayload {
    return {
      type: AssessmentActions.SET_NEW_SECTION_LOADING,
		  payload: data
    };
  }

  static SET_NEW_SECTION_ERROR = '[Assessment] Set new section error';
  setNewSectionError(data: boolean): ActionWithPayload {
    return {
      type: AssessmentActions.SET_NEW_SECTION_ERROR,
		  payload: data
    };
  }

  static SET_SYNC_STATUS = '[Assessment] Set sync status';
  setSyncStatus(data: string): ActionWithPayload {
    return {
      type: AssessmentActions.SET_SYNC_STATUS,
		  payload: data
    };
  }

}



// WEBPACK FOOTER //
// ./src/app/logics/assessment/assessment.actions.ts